(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-art-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gd-art-slideshow')) {
  customElements.define('gd-art-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.gd-screen__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = false;
      this.inView = true;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (this.suppressClick) {
          this.suppressClick = false;
          return;
        }
        if (button.dataset.action === 'pause') {
          this.paused = !this.paused;
          this.updateButton();
        } else if (button.dataset.slide !== undefined) {
          this.show(Number(button.dataset.slide));
        } else {
          this.show(this.index + (button.dataset.action === 'next' ? 1 : -1));
        }
        this.schedule();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.schedule();
      }, options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.isPrimary) return;
        this.suppressClick = false;
        this.pointer = {x:event.clientX, y:event.clientY};
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.suppressClick = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
          this.schedule();
        }
      }, options);
      this.addEventListener('pointercancel', () => { this.pointer = null; }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) {
          this.paused = true;
          this.show(index);
          this.updateButton();
          this.schedule();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, {threshold:0.1});
      this.observer.observe(this);
      this.updateButton();
      this.schedule();
    }
    updateButton() {
      const button = this.querySelector('[data-action="pause"]');
      if (!button) return;
      button.setAttribute('aria-label', this.paused ? button.dataset.play : button.dataset.pause);
      button.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    show(index) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === next);
        slide.setAttribute('aria-hidden', String(i !== next));
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === next);
        dot.setAttribute('aria-current', String(i === next));
      });
      this.index = next;
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && this.inView && !document.hidden && this.slides.length > 1) {
        const delay = Math.min(3000, Math.max(2000, Number(this.dataset.delay) || 3000));
        this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, delay);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gd-artist-contact"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gd-contact-feedback')){
  customElements.define('gd-contact-feedback',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.dialog=this.querySelector('dialog');
      if(!this.dialog||typeof this.dialog.showModal!=='function')return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.querySelector('[data-contact-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow;
        this.querySelector('[data-contact-notice]')?.focus({preventScroll:true});
      },options);
      this.dialog.addEventListener('click',(event)=>{
        if(event.target!==this.dialog)return;
        const box=this.dialog.getBoundingClientRect();
        if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.dialog.close();
      },options);
      this.previousOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow='hidden';
      const url=new URL(window.location.href);
      if(url.searchParams.has('contact_posted')){
        url.searchParams.delete('contact_posted');
        window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);
      }
    }
    disconnectedCallback(){
      if(this.dialog?.open){
        this.dialog.close();
        document.documentElement.style.overflow=this.previousOverflow;
      }
      this.abort?.abort();
      this.abort=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
